import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

async function fetchSiteSettings() {
  const { data, error } = await supabase.from("site_settings").select("key,value");
  if (error) return {} as Record<string, unknown>;
  const map: Record<string, unknown> = {};
  (data ?? []).forEach((r: { key: string; value: unknown }) => (map[r.key] = r.value));
  return map;
}

export function useSiteSettings() {
  return useQuery({
    queryKey: ["public-site-settings"],
    queryFn: fetchSiteSettings,
    staleTime: 60_000,
  });
}

export function useRecipesHidden(): boolean {
  const { data, isSuccess } = useSiteSettings();
  if (!isSuccess) return true;
  const v = data?.["hide_recipes"];
  return v === true || v === "true";
}

export function useProductsHidden(): boolean {
  const { data, isSuccess } = useSiteSettings();
  // Default nascosto durante il loading, evita flash della voce di menu
  if (!isSuccess) return true;
  const v = data?.["hide_products"];
  return v === true || v === "true";
}

// Google reviews aggregate — sostituibile in futuro con una chiamata a
// Google Places API senza toccare i consumer (hook stabile).
export type GoogleReviewsStats = { rating: number; count: number };

function toNumber(v: unknown, fallback: number): number {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string") {
    const n = Number(v.replace(",", "."));
    if (Number.isFinite(n)) return n;
  }
  return fallback;
}

export function useGoogleReviewsStats(fallback: GoogleReviewsStats): GoogleReviewsStats {
  const { data } = useSiteSettings();
  const rating = toNumber(data?.["google_rating"], fallback.rating);
  const count = Math.max(0, Math.round(toNumber(data?.["google_reviews_count"], fallback.count)));
  return { rating, count };
}
